import React, { Component } from 'react'
import compact from 'lodash/compact'
import moment from 'moment'
import numbro from 'numbro'
import pluralize from 'pluralize'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { selectLocalisation } from '../../../../store/site'
import { isJustGiving } from '../../../../lib/environment'
import { formatDistance, formatDuration, formatElevation } from 'supporticon/utils/fitness'
import { fetchOembedUrl } from 'constructicon/lib/oembed'
import currencySymbol, { symbolFromCurrencyCode } from '../../../../lib/currencySymbol'
import { currencyCode } from 'supporticon/utils/currencies'
import withToggle from 'constructicon/with-toggle'
import withStyles from 'constructicon/with-styles'
import styles from './styles'

import Button from 'constructicon/button'
import Confirm from '../../../ui/Confirm'
import Heading from 'constructicon/heading'
import Icon from 'constructicon/icon'
import Video from 'constructicon/video'
import ReplyToDonation from '../ReplyToDonation'
import RichText from 'constructicon/rich-text'

class Activity extends Component {
  constructor (props) {
    super(props)
    this.state = {
      embed: {},
      reply: props.reply,
      status: 'fetched'
    }
  }

  componentDidMount () {
    const { activityType, video } = this.props

    if (activityType === 'post' && video) {
      fetchOembedUrl(video)
        .then(embed => this.setState({ embed }))
    }
  }

  fitnessType () {
    const { customFitnessType, isCustom, type } = this.props

    if (isCustom) {
      return customFitnessType
    }

    switch (type) {
      case 'bike':
        return 'ride'
      case 'walk':
      case 'run':
      case 'ride':
      case 'swim':
      case 'hike':
        return type
      default:
        return 'run'
    }
  }

  render () {
    const {
      embed,
      reply,
      status
    } = this.state

    const {
      activityType,
      amount,
      classNames,
      country,
      createdAt,
      customFitnessType,
      currency,
      distance,
      duration,
      elevation,
      id,
      isPageOwner,
      image,
      isCustom,
      message,
      name,
      offline,
      onRemove,
      onToggleOn,
      page = {},
      uom,
      user
    } = this.props

    const handleRemove = () =>
      this.setState({ status: 'fetching' }, () => onRemove(id, activityType))

    const renderIcon = () => {
      switch (activityType) {
        case 'fitness':
          return (
            <div className={classNames.icon}>
              <Icon color='light' size={isCustom ? 1 : 1.333} name={isCustom ? 'heart' : this.fitnessType()} />
            </div>
          )
        case 'post':
          return (
            <div className={classNames.icon}>
              <Icon color='light' name='chat' />
            </div>
          )
        default:
          const symbol = currencySymbol(country)
          const icon = symbol === '£' ? 'pound' : symbol === '€' ? 'euro' : 'dollar'

          return (
            <div className={classNames.icon}>
              <Icon color='light' name={icon} />
            </div>
          )
      }
    }

    const renderContent = () => {
      switch (activityType) {
        case 'fitness':
          return (
            <div className={classNames.content}>
              <Heading tag='span' size={0}>
                {isCustom ? (
                  <span>
                    Logged{' '}
                    {numbro(distance).format('0,0')}{' '}
                    {pluralize(pluralize.singular(customFitnessType), distance)}{'. '}
                  </span>
                ) : (
                  <span>
                    Logged a{' '}
                    {!!distance && formatDistance(distance, uom === 'mi')}{' '}
                    {this.fitnessType()}{'. '}
                  </span>
                )}
                <small className={classNames.details}>
                  {!!duration && `Time: ${formatDuration(duration)}. `}
                  {!!elevation && `Elevation: ${formatElevation(elevation, uom === 'mi')}`}
                </small>
              </Heading>
              {!!message && (
                <article className={classNames.message} onClick={() => onToggleOn()}>
                  <RichText>{message}</RichText>
                </article>
              )}
              {isPageOwner && !isJustGiving() && (
                <footer className={classNames.actions}>
                  {status === 'fetching' ? (
                    <Icon name='loading' spin />
                  ) : (
                    <Confirm
                      tag={Button}
                      background='transparent'
                      foreground='dark'
                      size={-1}
                      spacing={0}
                      onConfirm={handleRemove}
                    >
                      <Icon name='trash' />
                      <span>Delete activity</span>
                    </Confirm>
                  )}
                </footer>
              )}
            </div>
          )
        case 'post':
          return (
            <div className={classNames.content}>
              <Heading tag='span' size={0}>
                {`${page.name} posted an update`}
              </Heading>
              {!!message && (
                <article className={classNames.message} onClick={() => onToggleOn()}>
                  <RichText>{message}</RichText>
                </article>
              )}
              {image && <img className={classNames.image} src={image} />}
              {embed.html && (
                <figure className={classNames.video}>
                  <Video embed={embed} />
                </figure>
              )}
              {isPageOwner && isJustGiving() && (
                <footer className={classNames.actions}>
                  {status === 'fetching' ? (
                    <Icon name='loading' spin />
                  ) : (
                    <Confirm
                      tag={Button}
                      background='transparent'
                      foreground='dark'
                      size={-1}
                      spacing={0}
                      onConfirm={handleRemove}
                    >
                      <Icon name='trash' />
                      <span>Delete post</span>
                    </Confirm>
                  )}
                </footer>
              )}
            </div>
          )
        default:
          const renderAmount = amount => {
            const defaultCurrency = currencyCode(country)

            return currency !== defaultCurrency
              ? `${currency} ${symbolFromCurrencyCode(currency)}${numbro(amount).format('0,0.[00]')}`
              : numbro(amount).formatCurrency('0,0.[00]')
          }

          return (
            <div className={classNames.content}>
              <Heading size={0}>
                {compact([
                  name || 'Anonymous',
                  'donated',
                  amount && renderAmount(amount),
                  offline && 'offline'
                ]).join(' ')}
              </Heading>
              {!!message && (
                <article className={classNames.message} onClick={() => onToggleOn()}>
                  <RichText>{message}</RichText>
                </article>
              )}
              {!!reply && (
                <div className={classNames.reply}>
                  {reply}
                </div>
              )}
              {isPageOwner && !offline && !reply && !isJustGiving() && (
                <footer className={classNames.actions}>
                  <ReplyToDonation
                    background='transparent'
                    donationId={id}
                    donorName={name}
                    foreground='dark'
                    onSuccess={reply => this.setState({ reply })}
                    pageId={page.id}
                    size={-1}
                    spacing={0}
                    tag={Button}
                    token={user.token}>
                    <Icon name='reply' />
                    <span>Send reply</span>
                  </ReplyToDonation>
                </footer>
              )}
            </div>
          )
      }
    }

    return (
      <li className={classNames.root}>
        {renderIcon()}
        {renderContent()}
        <span className={classNames.date}>{!!createdAt && moment(createdAt).fromNow()}</span>
      </li>
    )
  }
}

const mapStateToProps = (state) => ({
  ...selectLocalisation(state)
})

export default compose(
  connect(mapStateToProps),
  withToggle,
  withStyles(styles)
)(Activity)
